<app-section
  titleSection="Cartographie du bien"
  [isLargeTitle]="true"
  [isEditable]="false"
  [isActivable]="false"
>
  <div read-mode class="px-3 text-center">
    <img
      [src]="cartographieBinary"
      alt="Cartographie du bien"
      class="img-fluid rounded"
    />
  </div>
</app-section>
